

export enum AutomationDashboardId {
    RotoMoldingSupervisor = 'roto-molding-supervisor',
    Maintenance = 'maintenance',
    DeviceMonitor = 'device-monitor',
    PlasticsProduction = 'plastics-production',
    PlasticsMetrics = "plastics-metrics",
    RotoMachineCycleDashboard = "roto-machine-cycle-dashboard",
    ServerMetrics = "server-metrics",
    Security = "security",
    RaffleDisplay = "raffle-display",
    RaffleControl = "raffle-control",
    KolorcansPalletPacking = 'kolorcans-pallet-packing',
    ShippingBoard = "shipping-board",
    InjectionMolding = "injection-molding",
}
